import { omit } from 'lodash';

import { transformIncluded } from 'modules/common/utils';

export const transformQrCode = (item, included) => {
  const $item = transformIncluded(item, included);
  const { branch } = $item?.included;
  const branch_name = branch?.attributes?.branch_name;

  const x = {
    ...omit(item, ['attributes', 'links', 'relationships']),
    ...item?.attributes,
    branch_uuid: {
      value: item?.attributes?.branch_uuid,
      label: branch_name ? branch_name?.toUpperCase() : '',
    },
  };

  return x;
};

export const transformPayload = (item) => {
  const { branch_uuid } = item;
  const x = {
    ...omit(item, ['branch']),
    branch_uuid: branch_uuid?.value,
  };
  return x;
};
